export const SOFTLINE_FEATURE_PMS_STATUSABFRAGE_ABTEILUNGEN_MITARBEITER = 'pmsAbteilungenMitarbeiter';
export const SOFTLINE_FEATURE_PMS_STATUSABFRAGE_ABTEILUNGEN_MITARBEITER_DETAIL = 'pmsAbteilungenMitarbeiterDetail';

export const SOFTLINE_FEATURE_PMS_STATUSABFRAGE_ABTEILUNGEN = 'pmsAbteilungen';

export const SOFTLINE_PERMISSION_PMS_STATUSABFRAGE = 'STATUSABFRAGE';
export const SOFTLINE_CONFIG_PMS_STATUSABFRAGE_SEND_NOTIFICATION_COMPONENT = 'pms-statusabfrage'
